<template>
  <div class="home-container row" ref="homeContainer">
    <!-- <div class="home-header-container">
      <h4 class="header-title">Welcome {{ firstName }}</h4>
      <p class="header-subtitle q-ma-md">
        In your account you can view your shortlisted vehicles, search for new ones, and apply for a credit limit.
      </p>
    </div> -->
    <div class="home-action-container row justify-between col-12">
      <CalculatorButton
        class="home-button q-mb-sm q-mr-sm self-end"
        color="primary"
        rounded
        label="Home"
        :icon="homeIcon"
        iconDirection="left"
        outlined
        removeOpacity
        @click="handleHome"
      />
      <!-- <CalculatorButton
        class="self-end q-mb-sm"
        :color="showLeaseInclusion ? 'secondary' : undefined"
        rounded
        hasChevronIcon
        label="Lease inclusions"
        outlined
        removeOpacity
        @click="handleLeaseInclusionDialog"
      /> -->
    </div>
    <LeaseInclusionModal v-model="showLeaseInclusion" />
    <div
      :class="
        ['progress-steps-container', 'col-12', 'col-md-shrink', 'q-mb-md-md', ...[isHomePage && 'gt-sm']].filter((value) => value).join(' ')
      "
    >
      <ProgressSteps :activeSteps="activeStep" :steps="progressWizardSteps" />
    </div>
    <div class="home-body-container col-12 col-md-grow">
      <div v-if="isHomePage" class="progress-details-container bg-white q-ml-md-md">
        <div class="header" v-if="!primaryImage">
          <img src="/assets/icons/header-logo.svg" class="header-logo" />
        </div>
        <div
          v-else
          :style="{
            backgroundImage: 'url(' + primaryImage + ')',
            height: '350px',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }"
        />
        <div class="q-px-lg q-py-sm">
          <br />
          <MainHeadline align="center" :header="headerText" :body="bodyText" />
          <hr />
        </div>
        <div class="q-px-lg q-pt-sm">
          <ProgressList
            viewShortlist="completed"
            :businessDetails="businessDetailsStatus()"
            :approvals="approvalsStatus()"
            :reviewSignContract="reviewSignContractStatus()"
          />
        </div>
        <div class="q-px-lg body-footer-container q-py-lg">
          <CalculatorButton
            :class="['next-button', ...(!isStatusViewShortlist && ['continue-button'])].join(' ')"
            color="primary"
            outlined
            removeOpacity
            rounded
            hasChevronIcon
            @click="onClickHandler()"
            :loading="loading"
            :label="primaryContinueButtonLabel"
          />
        </div>
      </div>
      <template v-else>
        <router-view class="full-width q-pa-sm" />
      </template>
    </div>
  </div>
</template>

<script>
import ProgressSteps from '@/components/Calculator/CreditApplication/ProgressSteps';
import ProgressList from '@/components/Calculator/CreditApplication/ProgressList';
import { mapState, mapGetters } from 'vuex';
import MyCustomFunctions from '@/mixins/MyCustomFunctions.js';
import LeaseInclusionModal from '@/components/Calculator/LeaseInclusion/LeaseInclusionModal';
import CalculatorButton from '@/components/Calculator/CalculatorButton';
import { evaHomeOutline } from '@quasar/extras/eva-icons';
import MainHeadline from '@/components/Atoms/MainHeadline';
import {
  baseProgressActiveStepsFromStatus,
  mapActiveStepsWithoutShortlist,
  FULL_CREDIT_WIZARD_STEPS,
  COMPACT_CREDIT_WIZARD_STEPS
} from '@/utils/calculator/creditApplicationProgressWizard';
import { isScoreboardProductApplicationType } from '@/utils/calculator/scoreboardApplicationType';

export default {
  name: 'CalculatorHome',
  mixins: [MyCustomFunctions],
  computed: {
    pathName: function () {
      const pathName = this.$route.path;
      return pathName;
    },
    isHomePage: function () {
      return this.pathName === `/applications/${this.applicationId}`;
    },
    ...mapState({
      applicationId: (state) => (state.vehicleApplication ? state.vehicleApplication?.vehicleApplication?.applicationId : null),
      vehicleApplication: (state) => state.vehicleApplication?.vehicleApplication,
      scoreboard: (state) =>
        state.vehicleApplication?.vehicleApplication?.scoreboard ? state.vehicleApplication?.vehicleApplication?.scoreboard : null,
      user: (state) => state.auth.user
    }),
    ...mapGetters({
      isUserPrimaryApplicant: 'vehicleApplication/isUserPrimaryApplicant',
      orgProfile: 'theme/getScoreboard',
      isNZ: 'theme/isNZ'
    }),
    currentStatus() {
      return this.scoreboard?.status ? this.scoreboard?.status : null;
    },
    isStatusViewShortlist() {
      return this.currentStatus == 'viewShortlist' || !this.currentStatus;
    },
    primaryApplicant() {
      return this.scoreboard?.primaryApplicant ? this.scoreboard?.primaryApplicant : null;
    },
    isQuoteReAssigned() {
      if (!this.primaryApplicant || (this.isUserPrimaryApplicant && this.primaryApplicant && this.primaryApplicant.confirmed !== 'yes'))
        return true;
      else return false;
    },
    headerText() {
      if (this.isQuoteReAssigned) return `Welcome ${this.capitalizeFirstLetter(this.user.firstName)}.`;

      if (this.currentStatus == 'finished') return 'Congratulations!';
      else if (
        this.currentStatus == 'orderVerification' ||
        this.currentStatus == 'businessDetails' ||
        this.currentStatus == 'approvals' ||
        this.currentStatus == 'reviewAndSignContract'
      )
        return 'Application in progress';
      else return `Welcome ${this.capitalizeFirstLetter(this.user.firstName)}.`;
    },
    bodyText() {
      if (!this.currentStatus || this.currentStatus == 'viewShortlist')
        return `<p>Your account has been activated. Follow the easy online process to apply for a credit limit and your status will be updated at each stage.</p>
        ${
          this.isNZ
            ? '<p><b>Remember:</b> Our minimum eligibility criteria is a business or sole trader with an NZBN that’s been trading for 12 months or more and is GST-registered.</p>'
            : '<p><b>Remember:</b> Our minimum eligibility criteria is an ABN that’s been active for 2 or more years and is registered for GST with an annual turnover of more than $125,000.</p>'
        }
        <p>Credit criteria applies and FleetPartners will conduct a credit enquiry as part of your application process.</p>
        <p>Completing the application and getting an approved credit limit will allow you to order your vehicles only once you are happy with the final quotes and sign the lease documents.</p>`;

      if (this.isQuoteReAssigned)
        return `You\'ve been nominated as authorised officer of ${this.companyName} to participate in the review and approval of a vehicle quote, complete a credit application and sign the lease agreement.`;

      if (this.currentStatus == 'finished')
        return 'Your application is complete. Please select a vehicle to order and contact us to request a formal quote.';
      else if (
        this.currentStatus == 'viewShortlist' ||
        this.currentStatus == 'businessDetails' ||
        this.currentStatus == 'approvals' ||
        this.currentStatus == 'reviewAndSignContract'
      )
        return '';
      return '';
    },
    companyName() {
      return this.scoreboard?.companyDetails?.companyName ? this.scoreboard?.companyDetails?.companyName : '';
    },
    hasApplicationShortlists() {
      return (this.vehicleApplication?.calculator?.shortlists?.length ?? 0) > 0;
    },
    /** Public calculator with no shortlists, or CRM `applicationType: scoreboard` (treated as non–view-shortlist journey). */
    skipShortlistStep() {
      const t = String(this.vehicleApplication?.applicationType || '').toLowerCase();
      return t !== 'calculator' || !this.hasApplicationShortlists;
    },
    progressWizardSteps() {
      if (!this.skipShortlistStep) {
        return FULL_CREDIT_WIZARD_STEPS;
      }
      return COMPACT_CREDIT_WIZARD_STEPS;
    },
    baseProgressActiveSteps() {
      return baseProgressActiveStepsFromStatus(this.currentStatus, false);
    },
    activeStep() {
      const base = this.baseProgressActiveSteps;
      if (!this.skipShortlistStep) {
        return base;
      }
      return mapActiveStepsWithoutShortlist(base);
    },
    primaryImage() {
      if (this.orgProfile?.primaryImage) {
        return this.orgProfile.primaryImage;
      } else {
        return null;
      }
    },
    isApplicationFinished() {
      if (this.currentStatus == 'finished') return true;
      else return false;
    },
    primaryContinueButtonLabel() {
      if (this.isApplicationFinished) {
        return isScoreboardProductApplicationType(this.vehicleApplication) ? 'Return to Home' : 'Return to shortlist';
      }
      if (this.isStatusViewShortlist) return 'Get started';
      return 'Continue credit application';
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    if (!this.scoreboard) this.$router.push({ name: 'error' });
  },
  components: { ProgressList, ProgressSteps, CalculatorButton, LeaseInclusionModal, MainHeadline },
  data: function () {
    return {
      loading: false,
      showLeaseInclusion: false,
      homeIcon: evaHomeOutline
    };
  },
  methods: {
    businessDetailsStatus: function () {
      switch (this.currentStatus) {
        case 'viewShortlist':
          return 'pending';
        case 'businessDetails':
          return 'progress';
        case 'approvals':
          return 'completed';
        case 'reviewAndSignContract':
          return 'completed';
        case 'finished':
          return 'completed';
        default:
          return 'pending';
      }
    },
    approvalsStatus: function () {
      switch (this.currentStatus) {
        case 'viewShortlist':
          return 'pending';
        case 'businessDetails':
          return 'pending';
        case 'approvals':
          return 'progress';
        case 'reviewAndSignContract':
          return 'completed';
        case 'finished':
          return 'completed';
        default:
          return 'pending';
      }
    },
    reviewSignContractStatus: function () {
      switch (this.currentStatus) {
        case 'viewShortlist':
          return 'pending';
        case 'businessDetails':
          return 'pending';
        case 'approvals':
          return 'pending';
        case 'reviewAndSignContract':
          return 'progress';
        case 'finished':
          return 'completed';
        default:
          return 'pending';
      }
    },
    onClickHandler: async function () {
      this.loading = true;

      if (this.businessDetailsStatus() == 'pending') {
        await this.updateVehicleApplication('businessDetails', 'status');
        this.$router.push({ name: 'businessDetails' });
      } else if (this.businessDetailsStatus() == 'progress') {
        this.$router.push({ name: 'businessDetails' });
      } else if (this.approvalsStatus() == 'progress') {
        this.$router.push({ name: 'approvals' });
      } else if (this.reviewSignContractStatus() == 'progress') {
        this.$router.push({ name: 'reviewAndSignContract' });
      } else if (this.isApplicationFinished) {
        if (isScoreboardProductApplicationType(this.vehicleApplication)) {
          await this.navigateToScoreboardApplicationHome();
        } else {
          this.$router.push({ name: 'dashboard' });
        }
      }
      this.loading = false;
    },

    handleLeaseInclusionDialog() {
      this.showLeaseInclusion = true;
    },

    /**
     * Scoreboard "home" is `/applications/:applicationId`. Pushing when already there throws
     * NavigationDuplicated; reload so the action still refreshes the page.
     */
    async navigateToScoreboardApplicationHome() {
      const applicationId = this.applicationId;
      if (!applicationId) return;
      try {
        await this.$router.push({ name: 'applications', params: { applicationId } });
      } catch (err) {
        if (err && err.name === 'NavigationDuplicated') {
          window.location.reload();
          return;
        }
        throw err;
      }
    },

    handleHome() {
      if (isScoreboardProductApplicationType(this.vehicleApplication)) {
        this.navigateToScoreboardApplicationHome();
      } else {
        this.$router.push({ name: 'dashboard' });
      }
    }
  }
};
</script>

<style lang="sass">
.home-container
  max-width: 1440px
  padding: 20px
  display: flex
  flex-flow: row wrap
  width: 100%
  .home-header-container
    width: 100%
    text-align: center
    .header-title
      color: $primary
      font-size: 32px
    .header-subtitle
      font-size: 16px
      font-weight: 700
      line-height: 19.5px

  .home-action-container
    width: 100%
    .home-button.q-btn.calculator-button
      min-width: 114px
      .q-btn__wrapper
        padding: 0 15px
        .q-btn__content
          padding: 0
          display: flex
          flex-flow: row wrap
          justify-content: space-between
          align-items: center
          .q-icon
            padding-right: 10px
            font-size: 24px
  .progress-steps-container
    align-items: center
    max-width: 310px
    max-height: 350px
    width: 100%
  .home-body-container
    display: flex
    flex-flow: row wrap
    min-height: 350px
    height: 100%
    max-width: calc(100% - 310px)
    flex: 1
    .body-footer-container
      justify-self: end
      align-self: end
      text-align: end
      .next-button.calculator-button.q-btn
        width: 220px
        &.continue-button
          width: auto
    .progress-details-container
      width: 100%
      .header
        padding: 50px 0 0;
        text-align: center;
        background-color: #E9F3FE;
        background-image: url('/assets/icons/header-background.svg');
        background-position: center top;
        background-repeat: no-repeat;
        min-height: 350px;
      .header-logo
        width: 95%;
        max-width: 400px;
  @media (max-width: 1024px)
    .progress-steps-container
      max-width: 100%
    .home-body-container
      max-width: 100%
      flex: auto
  @media (max-width: 425px)
    .home-body-container .body-footer-container .next-button.calculator-button.q-btn, .next-button.calculator-button.q-btn.continue-button
      width: 100%!important
      max-width: 100%
</style>
